export default {
  // access local state by using {state} and rootState by {rootState}
  EMPTY_GRAPH: (state) => {
    state.g6_explore_data = { nodes: [], edges: [], combos: [] };
  },

  SET_GRAPH_SAVED_DATA: (state, data) => {
    state.g6_explore_data = data;
  },

  SET_GRAPH_DELETED_DATA: (state, data) => {
    state.g6_explore_data = { nodes: [], edges: [] };
    console.log('graph_deleted_data', data);
  },

  pushMyNode: (state, data) => {
    state.mainNodesOfExplore.push(data);
    console.log('Main Nodes Explore', state.mainNodesOfExplore);
  },

  SET_GRAPH_UPDATED_DATA: (state, data) => {
    console.log(data);

    state.g6_explore_data = data.g6_data.gdata;
  },

  ADD_NOTE_NODES_EDGES: (state, { type, data }) => {
    if (type === 'node') {
      state.g6_explore_data.nodes.push(data);
    } else if (type === 'edge') {
      state.g6_explore_data.edges.push(data);
    }
  },

  EXPAND_DATA: (state, data) => {
    const rawData = {};
    rawData.nodes = [...data.nodes, ...state.g6_explore_data.nodes];
    rawData.edges = [...data.edges, ...state.g6_explore_data.edges];
    rawData.combos = [...data.combos, ...state.g6_explore_data.combos];
    state.g6_explore_data = rawData;
  },

  setExploreGraphExpansion: (state, { exploreMapResponse, exploreEntity }) => {
    console.log(exploreEntity);
    const allNodes = [...state.g6_explore_data.nodes, ...exploreMapResponse.nodes];
    const newData = {};
    const uniqueNodes = allNodes.reduce((uniqueMap, node) => {
      if (uniqueMap[node.id] === undefined) {
        // eslint-disable-next-line no-param-reassign
        uniqueMap[node.id] = node;
      } else if (node.id === exploreEntity) {
        // eslint-disable-next-line no-param-reassign
        uniqueMap[node.id] = {
          id: exploreEntity,
          label: exploreEntity,
          type: 'circle',
          size: 40,
          style: {
            fill: '#fff',
            stroke: '#333',
          },
          cluster: exploreEntity,
        };
      }
      return uniqueMap;
    }, {});
    newData.nodes = Object.values(uniqueNodes);
    newData.edges = [...state.g6_explore_data.edges, ...exploreMapResponse.edges];
    console.log(exploreMapResponse.combos);
    if (exploreMapResponse.combos === undefined) {
      newData.combos = [...state.g6_explore_data.combos];
    } else {
      newData.combos = [...state.g6_explore_data.combos, ...exploreMapResponse.combos];
    }
    state.g6_explore_data = newData;
    console.log(state.g6_explore_data);
  },

  SET_G6_EXPLORE_DATA: (state, data) => {
    const newData = {};
    console.log('IT has been called');
    newData.nodes = data.nodes;
    newData.edges = data.edges;
    newData.combos = data.combos;
    state.g6_explore_data = newData;
  },

  SET_DIMENSION_DATA: (state, data) => {
    state.dimension_data = data;
  },
};
